<template>
  <div
    v-bind='$attrs'
    class='flex flex-col items-start justify-start'
  >
    <label
      v-if='label'
      :for='name'
      data-cy='label'
      class='block w-full text-sm font-normal text-gray-700'
    >
      <QuestionMarkCircleIcon
        v-if='help'
        class='question-mark-circle-icon mb-1 mr-0.5 inline-block h-4 w-4 cursor-pointer'
        @click='setHelpModalVisibility(true)'
      />
      <span
        :title='label'
        v-html='getLabel()'
      />
    </label>
    <div
      v-if='editMode'
      class='w-full'
    >
      <div class='w-full'>
        <textarea
          :id='name'
          :value='modelValue'
          :rows='rows'
          :cols='cols'
          :name='name'
          :disabled='disabled'
          class='block min-h-9 w-full rounded-md text-sm shadow-sm'
          :class='[
            resize,
            error ? "border-red-300 focus:ring-red-500 focus:border-red-500 caret-red-500 selection:bg-red-300 selection:text-red-900" : "border-gray-300 focus:ring-gray-500 focus:border-gray-500",
            disabled ? "bg-gray-50 text-gray-400" : "",
            inputClasses,
          ]'
          data-cy='text-value'
          @input='updateValue($event.target.value)'
        />
      </div>
      <InputError :error='error'/>
    </div>
    <div
      v-else
      class='w-full'
    >
      <div class='break-words line-clamp-3'>
        <span
          :title='modelValue'
          class='text-sm'
          data-cy='text-value'
        >
          {{ modelValue }}
        </span>
      </div>
    </div>
  </div>

  <Modal
    :open='helpVisible'
    :title='label'
    @close-modal='setHelpModalVisibility(false)'
  >
    <template #content>
      <p v-html='help'/>
    </template>
  </Modal>

</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import useInputFieldBase, { InputFieldProps, InputFieldComponents, InputFieldEmits } from '../../../compositions/useInputFieldBase'
  import useInputFieldHasHelp, { InputFieldHasHelpProps, InputFieldHasHelpComponents } from '../../../compositions/useInputFieldHasHelp'

  export default defineComponent({
    name: 'TextField',
    components: {
      ...InputFieldComponents,
      ...InputFieldHasHelpComponents,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
      rows: {
        type: Number,
        default: 4,
      },
      cols: {
        type: Number,
        default: 40,
      },
      resize: {
        type: String,
        default: 'resize-y',
        validator(value: string) {
          return ['resize-y', 'resize-x', 'resize-none', 'resize'].includes(value)
        },
      },
    },
    emits: [
      ...InputFieldEmits,
    ],
    setup() {
      const { helpVisible, setHelpModalVisibility } = useInputFieldHasHelp()
      const { updateValue, getLabel } = useInputFieldBase()

      return {
        updateValue, helpVisible, setHelpModalVisibility, getLabel,
      }
    },
  })
</script>
